import React, { useContext } from 'react';

import AuthContext from '@/contexts/Auth/AuthContext';
import { IntegrationSystem } from '@/shared/types';
import { ContentField, Typography } from '@/shared/ui';

import { SuspenseWithLoader } from '@/components/SuspenseWithLoader';

import { SocialProtectNoData } from '../SocialProtectNoData';

const RemoteUnavailableInformer: React.FC = () => (
  <div className="container" style={{ paddingTop: 24, paddingBottom: 24 }}>
    <ContentField
      icon="no_result"
      content={
        <Typography color="graphite">
          Сервіс «Соціальний захист» тимчасово недоступний. <br />
          Будь ласка, спробуйте оновити сторінку трохи пізніше.
        </Typography>
      }
    />
  </div>
);

class MspRemoteErrorBoundary extends React.Component<
  { children: React.ReactNode; fallback: React.ReactNode },
  { hasError: boolean }
> {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  state = { hasError: false };

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}

interface Props {
  children: React.ReactNode;
}

export const MspAccessGuard: React.FC<Props> = ({ children }) => {
  const { systems, storedLinks } = useContext(AuthContext);

  const noAccessFallback = (
    <div className="container" style={{ paddingTop: 16, paddingBottom: 16 }}>
      <SocialProtectNoData socialProtectLink={storedLinks?.externalLink?.socialProtect} />
    </div>
  );

  if (!systems.includes(IntegrationSystem.MSP)) {
    return noAccessFallback;
  }

  return (
    <MspRemoteErrorBoundary fallback={<RemoteUnavailableInformer />}>
      <SuspenseWithLoader>{children}</SuspenseWithLoader>
    </MspRemoteErrorBoundary>
  );
};
